import { render } from "./_PermitVersion.vue?vue&type=template&id=0f47a39e"
import script from "./_PermitVersion.vue?vue&type=script&lang=js"
export * from "./_PermitVersion.vue?vue&type=script&lang=js"

import exportComponent from "C:\\AgentPools\\FAOAgentPool\\_work\\32\\s\\WEPTW_Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__